import AntdPopover          from 'antd/lib/popover';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React                from 'react';

export type PopoverProps = {
	arrow?: boolean;
	className?: string;
	children: React.ReactNode;
	title?: React.ReactNode;
	content?: React.ReactNode;
	trigger?: 'hover' | 'focus' | 'click';
	placement?: TooltipPlacement;
	open?: boolean;
	onOpenChange?: (newOpen: boolean) => void;
	color?: string;
	styles?: Partial<Record<'root' | 'body', React.CSSProperties>>;
}

const Popover = React.forwardRef<any, PopoverProps>((props, ref) => {
	const child = React.isValidElement(props.children)
		? React.cloneElement(props.children as React.ReactElement, { ref } as any)
		: props.children;

	return (
		<AntdPopover
			classNames={{
				root: 'widesk-popover',
				body: props.className,
			}}
			arrow={props.arrow}
			trigger={props.trigger}
			title={props.title}
			content={props.content}
			placement={props.placement}
			open={props.open}
			onOpenChange={props.onOpenChange}
			color={props.color}
			styles={props.styles}
		>
			{child}
		</AntdPopover>
	);
});

export default Popover;
